import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    card: {
        display: 'flex',
        flexDirection: 'column',
        border: `1.5px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius,
        backgroundColor: theme.colors.white,
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease',

        '&:hover': {
            borderColor: theme.colors.violet_primary,
            boxShadow: `0 4px 12px 0 ${theme.colors.transp_violet}`,
        },

        '&$expanded': {
            gridColumn: '1 / -1',
            borderColor: theme.colors.violet_primary,
            boxShadow: `0 4px 12px 0 ${theme.colors.transp_violet}`,
        },
    },
    header: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(3),
        padding: theme.spacing(4),
        cursor: 'pointer',
        [theme.down('mobile')]: {
            flexWrap: 'wrap',
        },
    },
    typeIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 44,
        height: 44,
        borderRadius: theme.radius,
        background: color(theme.colors.violet_primary).fade(0.9).string(),
    },
    typeIconImg: {
        width: 24,
        height: 24,
    },
    typeIconFallback: {
        color: theme.colors.violet_primary,
        fontSize: 24,
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        minWidth: 0,
        flex: '1 1 auto',
    },
    name: {
        margin: 0,
        fontFamily: theme.font.secondary,
        fontSize: 16,
        lineHeight: 1.4,
        color: theme.colors.black,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    description: {
        margin: 0,
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
        color: theme.colors.grey_text,
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
        minHeight: 42,
    },
    metaCluster: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(0.5),
    },
    latestChip: {
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: '0.04em',
        color: theme.colors.violet_primary,
        background: color(theme.colors.violet_primary).fade(0.9).string(),
        borderRadius: theme.radius,
        padding: '2px 6px',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
    },
    date: {
        fontSize: 13,
        fontFamily: theme.font.primary,
        color: theme.colors.grey_text,
        whiteSpace: 'nowrap',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexShrink: 0,
        [theme.down('mobile')]: {
            flexBasis: '100%',
            justifyContent: 'flex-end',
            marginTop: theme.spacing(1),
        },
    },
    downloadButton: {
        whiteSpace: 'nowrap',
        [theme.down('mobile')]: {
            whiteSpace: 'normal',
        },
    },
    noFile: {
        fontSize: 13,
        fontFamily: theme.font.primary,
        color: theme.colors.grey_text,
        whiteSpace: 'nowrap',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        padding: theme.spacing(4),
        borderTop: `1px solid ${theme.colors.grey_light}`,
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    sectionHeader: {
        margin: 0,
        color: theme.colors.grey_text,
        fontSize: 14,
        fontFamily: theme.font.secondary,
        lineHeight: 1.25,
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
    },
    sectionHeaderRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: theme.spacing(2),
    },
    versionsCount: {
        fontSize: 12,
        fontFamily: theme.font.primary,
        color: theme.colors.grey_text,
    },
    text: {
        color: theme.colors.black,
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
    },
    markdown: {
        color: theme.colors.black,
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
        '& *': {
            font: 'revert',
            fontFamily: 'inherit',
            listStyle: 'revert',
            listStylePosition: 'inside',
        },
    },
    noInfo: {
        color: theme.colors.grey_text,
        fontFamily: theme.font.primary,
        fontSize: 14,
    },
    historyList: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
